/**
 * Generated by orval v8.8.1 🍺
 * Do not edit manually.
 * Reads API
 * API for managing post read tracking
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * Record that the current user has read a specific post. User ID is obtained from authentication context. CSRF token is sent via X-CSRF-TOKEN header.
 * @summary Add read to post
 */

export const AddReadToPostParams = zod
    .object({
        board_id: zod
            .enum([
                "review",
                "tiktoks",
                "beauty_news",
                "editorial_reviews",
                "expert_reviews",
                "activities",
                "test_modal",
                "test_modeless",
                "guidance",
            ])
            .describe("Board identifier"),
        post_id: zod.number().min(1).describe("Post identifier"),
    })
    .strict();

export const AddReadToPost201Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        reads_count: zod.number().nullish().describe("Total read count after this operation"),
        read: zod
            .object({
                read_id: zod.number().describe("Unique read identifier"),
                board_id: zod
                    .enum([
                        "review",
                        "tiktoks",
                        "beauty_news",
                        "editorial_reviews",
                        "expert_reviews",
                        "activities",
                        "test_modal",
                        "test_modeless",
                        "guidance",
                    ])
                    .describe("Board identifier"),
                post_id: zod.number().describe("Post identifier"),
                user_id: zod.number().describe("User ID who read the post"),
                post_user_id: zod.number().describe("User ID of the post author"),
                created_at: zod.string().datetime({ offset: true }),
                updated_at: zod.string().datetime({ offset: true }),
            })
            .strict()
            .optional()
            .describe("The read record that was created or updated"),
    })
    .strict();

export const AddReadToPost400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).describe("Failure flag"),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
    })
    .strict();
